import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.PublicSupplierConsentPage.title',
    defaultMessage: 'Give consent so that we can keep your profile for another year.',
  },
  titleConsentGiven: {
    id: 'containers.PublicSupplierConsentPage.titleConsentGiven',
    defaultMessage: 'Thank you for giving consent. We will keep your profile until {date}.',
  },
  instructions: {
    id: 'containers.PublicSupplierConsentPage.instructions',
    defaultMessage: "By clicking on 'Consent', you give us permission to keep your profile for one year",
  },
  giveConsent: {
    id: 'containers.PublicSupplierConsentPage.giveConsent',
    defaultMessage: "Consent",
  }
})
